import React from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { toast } from '../hooks/use-toast';

const CTASection = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    toast({
      title: "Message Sent!",
      description: "We'll get back to you soon.",
    });
  };

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-r from-[#1e3a8a] to-[#2563eb]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center">
          {/* Left Content */}
          <div className="text-white">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight">
              Not Sure Where to Begin Your Care Journey?
            </h2>
            <p className="text-white/90 text-sm sm:text-base md:text-lg mb-8 leading-relaxed">
              Tell us your concerns and We will guide you to our Verified , Trusted Specialist Network and next steps .
            </p>
            <Button className="bg-white text-[#1e3a8a] hover:bg-gray-100 px-6 sm:px-8 py-4 sm:py-6 text-base sm:text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300">
              Connect With Us →
            </Button>
          </div>

          {/* Right - Contact Form */}
          <div className="bg-white rounded-2xl p-4 sm:p-6 lg:p-8 shadow-2xl">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-6">
              Have questions? Get in touch!
            </h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <Input
                type="text"
                placeholder="Your Name"
                className="w-full min-h-[44px]"
                required
              />
              <Input
                type="email"
                placeholder="Your Email"
                className="w-full min-h-[44px]"
                required
              />
              <Input
                type="tel"
                placeholder="Phone Number"
                className="w-full min-h-[44px]"
              />
              <Textarea
                placeholder="Your Message"
                className="w-full min-h-[120px]"
                required
              />
              <p className="text-xs text-gray-500 leading-relaxed">
                <span className="font-semibold">Note:</span> This form is meant for general enquiries only. Kindly request not to share your sensitive personal data or detailed health information. For clinical concerns or medical advice, please book an appointment or contact us directly.
              </p>
              <Button
                type="submit"
                aria-label="Submit enquiry form"
                className="w-full bg-[#1e3a8a] hover:bg-[#1e3a8a]/90 text-white py-6 text-lg rounded-full transition-all duration-300 min-h-[48px]"
              >
                Submit
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;